import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

//styles & images
import styles from './Notifs.module.scss';


//Global state
import { useGlobalContext } from '../../context/GlobalContext';
import { deleteNotifAction, getNotifsAction, putNotifAction } from '../../actions/authActions';
import { MdWarning } from 'react-icons/md';
import { IoCloseCircleSharp } from 'react-icons/io5';
import { TOOL_ID } from '../../actions';

export default function NotifsPage() {

  const [context, dispatch] = useGlobalContext();
  const notifs = context?.auth?.notifs || [];
  const { userAuth } = context?.auth;

  const getNotifs = useCallback(() => { getNotifsAction(dispatch, 'Medocta') }, [dispatch]);

  useEffect(() => {
    getNotifs();
  }, [getNotifs]);

  async function deleteNotif(e, id) {
    e.preventDefault()
    await deleteNotifAction(dispatch, id);
    await getNotifs();
  }

  const getNavigate = (id) => {
    if (userAuth?.tools.find((t) => t.tool === TOOL_ID && t.role === "Admin")) {
      return `/question/${id}`;
    } else if (userAuth?.tools.find((t) => t.tool === TOOL_ID && t.role === "Owner")) {
      return `/question-assign/${id}`;
    } else if (userAuth?.tools.find((t) => t.tool === TOOL_ID && t.role === "Member")) {
      return `/question-member/${id}`;
    }
  }

  return (
    <div className={`page-container ${styles.container}`}>
      <div className="content">
        {userAuth && notifs?.map((n) => <Link
          key={n?._id}
          to={getNavigate(n.objId)}
          onClick={async (e) => {
            if (n.new) {
              await putNotifAction(dispatch, n._id, { new: false });
            }
          }}
          className={`${styles.notif} ${n.new ? styles.new : ''}`}>
          <p ><span className="bold">{n.description} </span> - {n?.createdAt && format(new Date(n?.createdAt), "dd/MM/yyyy")}</p>
          <p>{n.title}</p>
          {n?.delay >= 7 && <p className="text-error"><MdWarning size={18} /> {n.delay} jours </p>}
          {n?.delay < 7 && <p className="text-success">{n.delay} jours </p>}
          {n.new && <div className={styles.puce} />}
          {!n.new &&
            <button
              type='button'
              onClick={(e) => deleteNotif(e, n._id)}
            >
              <IoCloseCircleSharp size={20} color={'#b5b5b5'} />
            </button>
          }
        </Link>)}
      </div>
    </div>
  )
}
